import { render, staticRenderFns } from "./CalendarView.vue?vue&type=template&id=72664cfe"
import script from "./CalendarView.ts?vue&type=script&lang=ts&external"
export * from "./CalendarView.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports